import React from 'react'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  className?: string
  isDisabled?: boolean
}

export function SecondaryButton({
  children,
  isDisabled = false,
  className = '',
  type = 'button',
  onClick,
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      disabled={isDisabled}
      onClick={onClick}
      className={`
        h-10 rounded-xl flex justify-center items-center gap-2 inline-flex
        ${
          isDisabled
            ? 'border border-[#1d1b20]/[0.12] bg-transparent'
            : 'border border-[#79747e] bg-transparent hover:bg-hover:bg-[#65558F14]/[0.08] active:bg-[#65558f]/[0.12]'
        }
        ${className}
      `}
      {...props}
    >
      <div
        className={`
          w-full h-full flex justify-center items-center px-6 py-2.5 gap-2
        `}
      >
        <div
          className={`
            text-center text-sm font-['Geist'] leading-tight tracking-tight
            inline-flex items-center gap-1
            ${isDisabled ? 'text-neutral-800/40' : 'text-neutral-800'}
          `}
        >
          {children}
        </div>
      </div>
    </button>
  )
}
